// All the values that can be sent to the list exam endpoint to filter the exams we want to get
export enum ExamResultFileCategoryEnum {
    EXAM_FILE = 'exam_file',
    ACHIEVEMENT_CERTIFICATE = 'achievement_certificate',
    EXAM_CORRECTION_FILE = 'exam_correction_file',
}